import { render, staticRenderFns } from "./DropdownSubComponent.vue?vue&type=template&id=48d64eb6"
import script from "./DropdownSubComponent.vue?vue&type=script&lang=js"
export * from "./DropdownSubComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports